// extracted by mini-css-extract-plugin
module.exports = {"comment-images-box":"comment-images_comment-images-box__EZCXZ","comment-image":"comment-images_comment-image__3XcA9","play-btn":"comment-images_play-btn__cYBa-"};